// Copyright ©️ 2026 eVolve MEP, LLC

import type { MachineProfile } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

type Props = {
  option: { original: MachineProfile };
};

/** An option for a machine profile. Intended to be passed as a `renderOption` prop to `SearchableSelect` */
export const BenderProfileOption = ({
  option: {
    original: { machineName, name },
  },
}: Props) => (
  <>
    <Text>{name}</Text>
    <Text c="dimmed">{machineName}</Text>
  </>
);
